var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "talk",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.03,
    height: 24.316,
    viewBox: "0 0 26.03 24.316",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M22.825,2.163h-.039v-.04A3.209,3.209,0,0,0,19.58-1.082H3.206A3.209,3.209,0,0,0,0,2.124v10.02a3.209,3.209,0,0,0,3.094,3.2v4.641L5.37,18.406a3.189,3.189,0,0,0,1.082.189H16.27l6.667,4.639V18.593a3.21,3.21,0,0,0,3.094-3.2V5.369a3.209,3.209,0,0,0-3.206-3.206Zm-21.3,9.981V2.124A1.682,1.682,0,0,1,3.206.443H19.58a1.682,1.682,0,0,1,1.681,1.68v10.02a1.682,1.682,0,0,1-1.681,1.681H9.283L4.619,17.069V13.824H3.206a1.682,1.682,0,0,1-1.681-1.681Zm22.98,3.245a1.682,1.682,0,0,1-1.681,1.681H21.412v3.245l-4.664-3.245H7.29l2.472-1.72H19.58a3.209,3.209,0,0,0,3.206-3.206V3.688h.039a1.682,1.682,0,0,1,1.681,1.68Zm0,0",
    transform: "translate(-0.001 1.082)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M186.43,175.148h1.519v1.519H186.43Zm0,0",
    transform: "translate(-178.848 -167.98)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M261.43,175.148h1.519v1.519H261.43Zm0,0",
    transform: "translate(-250.797 -167.98)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M336.43,175.98h1.519V177.5H336.43Zm0,0",
    transform: "translate(-322.747 -168.779)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComments);
export default __webpack_public_path__ + "static/media/comments.2e43c83c7c9732e29f026d955a658cde.svg";
export { ForwardRef as ReactComponent };